$(function() {
  // FAQ, Ingredient Glossary Accordion
  let accordion_wrap = $('.js_accordion_wrap'),
      accordion_btn = $('.js_accordion_btn'),
      accordion_body = $('.js_accordion_body');
  accordion_body.hide();
  accordion_wrap.removeClass('is_open');

  accordion_btn.on("click", function(){
    $(this).next().slideToggle();
    $(this).closest('.js_accordion_wrap').toggleClass('is_open');
  });

  // Ingredient Glossary Tab Switching
  let tab_wrap = $('.js_tab_wrap'),
      tab_btn = $('.js_tab_btn'),
      tab_body = $('.js_tab_body');
  tab_btn.click(function(){
		tab_btn.removeClass('is_active');
		$(this).addClass('is_active');
		tab_body.removeClass('is_active');
		const index = $(this).index();
		tab_body.eq(index).addClass('is_active');
	});

  // ShopList Tab Switching
  let tab_shopBtn = $('.js_shopTab_btn'),
      tab_shopBody = $('.js_shopTab_body'),
      headerTarget = $('#shopify-section-header'),
      scrollTarget = $('#shopBody'),
      scrollDuration = 300,
      scrollEasing = 'swing',
      scrollAmount = '';
  tab_shopBtn.click(function(){

		tab_shopBtn.removeClass('is_active');
		$(this).addClass('is_active');
		tab_shopBody.removeClass('is_active');

    const shopTarget = $(this).data('shopbtn');
    tab_shopBody.filter('[data-shopbody="' + shopTarget + '"]').addClass('is_active');
    scrollAmount = scrollTarget.offset().top - headerTarget.outerHeight();
    $('html, body').stop().animate({scrollTop: scrollAmount}, scrollDuration, scrollEasing);
	});

  // ShopList Judge URL Parameter
  var urlParam = location.search.substring(1);
  if(urlParam){
    var param = urlParam.split('&'),
        paramArray = [];
    for (i = 0; i < param.length; i++){
      var paramItem = param[i].split('=');
      paramArray[paramItem[0]] = paramItem[1];
    }
    if(urlParam){
      var target_tabShopBtn = tab_shopBtn.filter('[data-shopbtn="' + paramArray.shop + '"]'),
          target_tabShopBody = tab_shopBody.filter('[data-shopbtn="' + paramArray.shop + '"]');
      if(target_tabShopBtn.length > 0){
        tab_shopBtn.removeClass('is_active');
        target_tabShopBtn.addClass('is_active');
        tab_shopBody.removeClass('is_active');
        target_tabShopBody.addClass('is_active');
        scrollAmount = scrollTarget.offset().top - headerTarget.outerHeight();
        $('html, body').stop().animate({scrollTop: scrollAmount}, scrollDuration, scrollEasing);
      }
    }
  }

  // Our Biology Tab Ingredient Glossary Slider
  const breakpoint = 767;
  let ingredientSwiper,
      ingredientSwiperBool;
  $(window).on('load', function(){
    if( breakpoint < window.innerWidth){
      ingredientSwiperBool = false;
    }else{
      createIngredientSwiper();
      ingredientSwiperBool = true;
    }
  });
  $(window).on('resize', function(){
    if( breakpoint < window.innerWidth && ingredientSwiperBool){
      ingredientSwiper.destroy(false,true);
      ingredientSwiperBool = false;
    }else if( breakpoint >= window.innerWidth && !(ingredientSwiperBool)){
      createIngredientSwiper();
      ingredientSwiperBool = true;
    }
  });
  const createIngredientSwiper = () =>{
    ingredientSwiper = new Swiper('.js_ingredient_swiper_container', {
      loop: true,
      speed: 2000,
      slidesPerView: 'auto',
      centeredSlides: true,
      autoplay: {
        delay: 4000,
      },
      pagination: {
         el: '.js_ingredient_swiper_pagination',
       },
      navigation: {
        nextEl: '.js_ingredient_swiper_button_next',
        prevEl: '.js_ingredient_swiper_button_prev',
      },
    });
  }

  $('a[href^="#"]').click(function(){
    var headerHight = $(".header-section").outerHeight();
      var speed = 500;
      var href= $(this).attr("href");
      var target = $(href == "#" || href == "" ? 'html' : href);
      var position = target.offset().top - headerHight;
      $("html, body").animate({scrollTop:position}, speed, "swing");
      return false;
  });

});
